import React from 'react'; 

import {GeneralEditPage} from '../../../components/shared/general-page/';
import { DevicesService, FirmwareVersionsService, HardwareVersionsService, SiutsService, SitesService, CompaniesService, PowerSupplyTypesServiceService } from '../../../services';
import DeviceEditor from '../components/device-editor';
import { withRouter } from 'react-router-dom';

const DeviceEditPage = (props) => {
    const _devicesService = new DevicesService();
    const _firmwareVersionsService = new FirmwareVersionsService();
    const _hardwareVersionsService = new HardwareVersionsService();
    const _siutsService = new SiutsService();
    const _sitesService = new SitesService();
    const _companiesService = new CompaniesService();
    const _powerSupplyTypesServiceService = new PowerSupplyTypesServiceService();

    const configuration = {
        masterService: _devicesService, 
        containerClassName: 'device-edit-page',
        editorComponent: DeviceEditor,  
        dictionaries: {
            siuts: _siutsService.getItems,
            sites: _sitesService.getItems,
            firmwareVersions: _firmwareVersionsService.getItems,
            hardwareVersions: _hardwareVersionsService.getItems,
            companies: _companiesService.getItems,
            powerSupplyTypes: _powerSupplyTypesServiceService.getItems
        },    
        successSaveRedirectTo: `/devices/${props.match.params.id}/`,
        postActions: (device) => {
            console.log('d-e-p');
            props.updateDevice(device);
        }
    }

    return (
        <GeneralEditPage {...configuration}></GeneralEditPage>
    );
}

export default withRouter(DeviceEditPage);